import React from 'react';
import { Button, TextField, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { useUpsertRoomMutation } from '../../../../services/ConfigurationService';

export function AddRoomDialog({ defaultCenterId, onSuccess }: { defaultCenterId: string; onSuccess?: () => void }) {
  const [open, setOpen] = React.useState(false);
  const [code, setCode] = React.useState('');
  const [description, setDescription] = React.useState('');
  const [upsertRoom, { isLoading }] = useUpsertRoomMutation();
  const [error, setError] = React.useState<string | null>(null);

  const handleSave = async () => {
    if (!code.trim()) {
      setError('Code is required.');
      return;
    }
    const id = `${defaultCenterId}-${code}`;
    await upsertRoom({ id, centerId: defaultCenterId, code, description });
    setOpen(false);
    setCode('');
    setDescription('');
    setError(null);
    if (onSuccess) onSuccess();
  };

  return (
    <React.Fragment>
      <Button variant="contained" color="primary" onClick={() => setOpen(true)}>
        Add Room
      </Button>
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="xs" fullWidth>
        <DialogTitle>Add Room</DialogTitle>
        <DialogContent>
          <TextField
            label="Code"
            value={code}
            onChange={e => setCode(e.target.value)}
            fullWidth
            margin="normal"
            autoFocus
          />
          <TextField
            label="Description"
            value={description}
            onChange={e => setDescription(e.target.value)}
            fullWidth
            margin="normal"
          />
          {error && <div style={{ color: 'red', marginTop: 8 }}>{error}</div>}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)} variant="outlined">Cancel</Button>
          <Button onClick={handleSave} variant="contained" color="primary" disabled={isLoading}>Save</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
